module.exports = __webpack_public_path__ + "static/media/strip-mobile-dashboard-desk.512111ca.png";